import { Logout, LogoutClearLocalStorage, getData, isAuth } from "actions";
import axios from "axios";
import {
  API_URL_agent,
  API_URL_countTicketStatus,
  API_URL_department,
  API_URL_kbSetting,
  API_URL_notification,
  API_URL_refresh,
  API_URL_ticketCountDepartment,
  API_URL_ticketCountin,
  URL_WS,
} from "constants/api";
import React, {
  createContext,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { useDispatch } from "react-redux";
import { notificationReducers } from "redux/notificationSlice";
import { encryptArrayLocalStorage } from "utils/encryptArrayLocalStorage";
import { encrypted } from "utils/crypto";
import { random } from "lodash";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [datauser, setDatauser] = useState("");
  const dispatch = useDispatch();
  const [departement, setDepartement] = useState([]);
  const [paginateKb, setPaginateKb] = useState("");
  const [countTicketDept, setCountTicketDept] = useState([]);
  const [countTicketInbox, setCountTicketInbox] = useState("");
  const [countStatus, setCountStatus] = useState([]);

  //notify websocket
  const [wsTotalTicket, setWsTotalTicket] = useState(false);
  const [wsStatusSendReply, setWsStatusSendReply] = useState(false);

  //refresh Websocket
  const [refreshWebsocket, setRefreshWebsocket] = useState(false);

  //update trigger
  const [updateUser, setUpdateUser] = useState(false);
  const [updateCountTicket, setUpdateCountTicket] = useState(false);
  const [updateNotification, setUpdateNotification] = useState(false);

  // const [authState, setAuthState] = useState({
  //   access: localStorage.getItem("sseccaxds"),
  //   refresh: localStorage.getItem("hserfercxz"),
  // });

  const interval = useRef(null);
  const activityTimeout = useRef(null);

  const getNotification = useCallback(
    async (params) => {
      getData(
        API_URL_notification,
        params,
        { dispatch, redux: notificationReducers },
        "GET_NOTIFICATION"
      );
    },
    [dispatch]
  );

  const loadDatauser = () => {
    if (isAuth() === false) {
      setDatauser("");
    } else {
      axios({
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
        },
        url: API_URL_agent + isAuth().user_id + "/",
      })
        .then((response) => {
          setDatauser(response.data);
          encryptArrayLocalStorage(
            "noissimrepedc",
            response.data.group_permissions
          );
        })
        .catch((error) => {
          console.log(error.response.data);
          if (
            error.response.data.code === "user_inactive" ||
            error.response.data.code === "token_not_valid"
          ) {
            localStorage.removeItem("sseccaxds");
            localStorage.removeItem("hserfercxz");
          }
          setDatauser("");
        });
    }
  };

  const loadDataPaginateKnowledge = () => {
    axios({
      method: "GET",
      url: API_URL_kbSetting + "1/",
    })
      .then((response) => {
        setPaginateKb(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const loadDataDepartement = () => {
    axios({
      method: "GET",
      params: {
        user: encrypted(datauser.id),
      },
      url: API_URL_department,
    })
      .then((response) => {
        setDepartement(response.data.results);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const loadDataTicketStatusDepartement = () => {
    axios({
      method: "GET",
      url: API_URL_countTicketStatus,
    })
      .then((response) => {
        setCountStatus(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const loadDataTicketStatusInbox = () => {
    axios({
      method: "GET",
      params: { user: encrypted(datauser.id) },
      url: API_URL_ticketCountin,
    })
      .then((response) => {
        setCountTicketInbox(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const loadDataCountTicketDepartement = () => {
    if (departement.length !== 0) {
      const dataCountStatusPerDepartement =
        departement.length * countStatus.count;

      departement.map((item, index) => {
        for (let i = 1; i < countStatus.count + 1; i++) {
          axios({
            method: "GET",
            url: `${API_URL_ticketCountDepartment}?department=${item.id}&status=${i}`,
          })
            .then((response) => {
              setCountTicketDept((countTicketDept) => [
                ...countTicketDept,
                response.data,
              ]);
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
      const sliceNotToDuplicateData = countTicketDept.slice(
        0,
        dataCountStatusPerDepartement
      );
      setCountTicketDept(sliceNotToDuplicateData);
    }
  };

  useEffect(() => {
    loadDataPaginateKnowledge();
    loadDataTicketStatusDepartement();
    loadDatauser();
  }, []);

  useEffect(() => {
    if (isAuth() !== false) {
      loadDatauser();
    }
  }, [updateUser]);

  // Update Count Ticket jika ada perubahan data dari child
  useEffect(() => {
    if (datauser !== "") {
      loadDataTicketStatusInbox();
    }
    setTimeout(() => {
      if (datauser !== "") {
        loadDataTicketStatusInbox();
      }
      loadDataCountTicketDepartement();
    }, 1000);
  }, [updateCountTicket]);

  useEffect(() => {
    if (datauser !== "") {
      loadDataTicketStatusInbox();
      loadDataDepartement();
    }
  }, [datauser]);

  useEffect(() => {
    if (datauser !== "") {
      const params = `?user_id=${datauser.id}`;
      getNotification(params);
    }
  }, [updateNotification]);

  useEffect(() => {
    encryptArrayLocalStorage("tnemtrapedbnc", departement);
    loadDataCountTicketDepartement();
  }, [departement]);

  // update data jika wsTotalTicket berubah
  useEffect(() => {
    if (datauser !== "" && wsTotalTicket !== false) {
      loadDataTicketStatusInbox();
      const params = `?user_id=${datauser.id}`;
      getNotification(params);
    }
    if (departement.length > 0 && wsTotalTicket !== false) {
      loadDataCountTicketDepartement();
    }
    setWsTotalTicket(false);
  }, [datauser, departement, wsTotalTicket]);

  // Setup Websocket
  let attempt = 1;
  let ws;
  function setupWebSocket() {
    ws = new WebSocket(URL_WS);

    ws.onopen = () => {
      console.log("WebSocket Connected");
      setRefreshWebsocket(random(10000));
      attempt = 1; // reset attempt counter on successful connection
    };

    // trigger untuk update count ticket jika terjadi penambahan di backend
    ws.onmessage = (event) => {
      const data = JSON.parse(event.data);
      console.log(data);
      if (data.status_send_reply) {
        setWsStatusSendReply(data.status_send_reply);
      }
      if (data.total_tickets) {
        setWsTotalTicket(data.total_tickets);
      }
    };

    ws.onclose = () => {
      let timeout = Math.min(10000, 500 * Math.pow(2, attempt));
      console.log(`WebSocket disconnected. Reconnecting in ${timeout}ms`);
      if (ws) {
        ws.close(); // close current WebSocket connection
      }
      setTimeout(setupWebSocket, timeout);
      attempt++;
    };

    ws.onerror = (error) => {
      console.error("WebSocket Error:", error);
    };
  }

  useEffect(() => {
    setupWebSocket();

    // Clean-up function
    return () => {
      if (ws) {
        ws.close();
      }
    };
  }, []);

  useEffect(() => {
    if (
      datauser !== "" &&
      localStorage.getItem("sseccaxds") &&
      localStorage.getItem("hserfercxz")
    ) {
      const checkForExpiredToken = async () => {
        if (
          localStorage.getItem("sseccaxds") &&
          localStorage.getItem("hserfercxz")
        ) {
          //check Access
          if (localStorage.getItem("sseccaxds")) {
            const payloadAccess = JSON.parse(
              atob(localStorage.getItem("sseccaxds").split(".")[1])
            );
            const expirationAccess = payloadAccess.exp;
            const current_timeAccess = Math.floor(new Date().getTime() / 1000);
            if (current_timeAccess > expirationAccess) {
              Logout();
            }
          }

          //Token Access pass to check Refresh and then refresh token
          if (localStorage.getItem("hserfercxz")) {
            const payloadRefresh = JSON.parse(
              atob(localStorage.getItem("hserfercxz").split(".")[1])
            );
            const expirationRefresh = payloadRefresh.exp;
            const current_timeRefresh = Math.floor(new Date().getTime() / 1000);

            if (current_timeRefresh > expirationRefresh) {
              Logout();
            } else {
              try {
                const response = await axios.post(API_URL_refresh, {
                  refresh: localStorage.getItem("hserfercxz"),
                });

                if (response.data && response.data.access) {
                  localStorage.setItem("sseccaxds", response.data.access);
                }
              } catch (err) {
                Logout();
              }
            }
          }
        } else if (
          localStorage.getItem("sseccaxds") &&
          localStorage.getItem("hserfercxz") === null
        ) {
          Logout();
        }
      };

      const intervalId = setInterval(checkForExpiredToken, 10 * 60 * 1000);

      return () => {
        clearInterval(intervalId);
      };
    }
  }, [
    datauser,
    localStorage.getItem("sseccaxds"),
    localStorage.getItem("hserfercxz"),
  ]);

  useEffect(() => {
    if (datauser !== "") {
      const resetActivityTimer = () => {
        if (activityTimeout.current) {
          clearTimeout(activityTimeout.current);
        }

        activityTimeout.current = setTimeout(() => {
          if (
            localStorage.getItem("sseccaxds") ||
            localStorage.getItem("hserfercxz")
          ) {
            Logout();
          }
        }, 120 * 60 * 1000); // Set ke inaktif jika tidak ada aktivitas dalam 2 jam
      };

      window.addEventListener("mousemove", resetActivityTimer);
      window.addEventListener("keydown", resetActivityTimer);
      window.addEventListener("scroll", resetActivityTimer);

      return () => {
        if (activityTimeout.current) {
          clearTimeout(activityTimeout.current);
        }

        window.removeEventListener("mousemove", resetActivityTimer);
        window.removeEventListener("keydown", resetActivityTimer);
        window.removeEventListener("scroll", resetActivityTimer);
      };
    }
  }, [
    datauser,
    localStorage.getItem("sseccaxds"),
    localStorage.getItem("hserfercxz"),
  ]);

  return (
    <AuthContext.Provider
      value={{
        datauser,
        setDatauser,
        refreshWebsocket,
        wsTotalTicket,
        setWsTotalTicket,
        wsStatusSendReply,
        setWsStatusSendReply,
        countTicketDept,
        countTicketInbox,
        paginateKb,
        updateCountTicket,
        setUpdateCountTicket,
        updateUser,
        setUpdateUser,
        updateNotification,
        setUpdateNotification,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
